export const INVITED = 'Invited';
export const DECLINED = 'Declined';
export const ACTIVE = 'Active';
export const REMOVED = 'Removed';
